import { c as o, cB as i, cM as r, cE as e } from "./ghl-ui.es384.js";
import { fadeInHeightExpandTransition as t } from "./ghl-ui.es1315.js";
import { iconSwitchTransition as a } from "./ghl-ui.es1318.js";
const p = o([i("upload", "width: 100%;", [r("dragger-inside", [i("upload-trigger", `
 display: block;
 `)]), r("drag-over", [i("upload-dragger", `
 border: var(--n-dragger-border-hover);
 `)])]), i("upload-dragger", `
 cursor: pointer;
 box-sizing: border-box;
 width: 100%;
 text-align: center;
 border-radius: var(--n-border-radius);
 padding: 24px;
 opacity: 1;
 transition:
 opacity .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 background-color: var(--n-dragger-color);
 border: var(--n-dragger-border);
 `, [o("&:hover", `
 border: var(--n-dragger-border-hover);
 `), r("disabled", `
 cursor: not-allowed;
 `)]), i("upload-trigger", `
 display: inline-block;
 box-sizing: border-box;
 opacity: 1;
 transition: opacity .3s var(--n-bezier);
 `, [o("+", [i("upload-file-list", "margin-top: 8px;")]), r("disabled", `
 opacity: var(--n-item-disabled-opacity);
 cursor: not-allowed;
 `), r("image-card", `
 width: 96px;
 height: 96px;
 `, [i("base-icon", `
 font-size: 24px;
 `), i("upload-dragger", `
 padding: 0;
 height: 100%;
 width: 100%;
 display: flex;
 align-items: center;
 justify-content: center;
 `)])]), i("upload-file-list", `
 line-height: var(--n-line-height);
 opacity: 1;
 transition: opacity .3s var(--n-bezier);
 `, [o("a, img", "outline: none;"), r("disabled", `
 opacity: var(--n-item-disabled-opacity);
 cursor: not-allowed;
 `, [i("upload-file", "cursor: not-allowed;")]), r("grid", `
 display: grid;
 grid-template-columns: repeat(auto-fill, 96px);
 grid-gap: 8px;
 margin-top: 0;
 `), i("upload-file", `
 display: block;
 box-sizing: border-box;
 cursor: default;
 padding: 0px 12px 0 6px;
 transition: background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 `, [t(), i("progress", [t({
  foldPadding: !0
})]), o("&:hover", `
 background-color: var(--n-item-color-hover);
 `, [i("upload-file-info", [e("action", `
 opacity: 1;
 `)])]), r("image-type", `
 border-radius: var(--n-border-radius);
 text-decoration: underline;
 text-decoration-color: #0000;
 `, [i("upload-file-info", `
 padding-top: 0px;
 padding-bottom: 0px;
 width: 100%;
 height: 100%;
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 6px 0;
 `, [i("progress", `
 padding: 2px 0;
 margin-bottom: 0;
 `), e("name", `
 padding: 0 8px;
 `), e("thumbnail", `
 width: 32px;
 height: 32px;
 font-size: 28px;
 display: flex;
 justify-content: center;
 align-items: center;
 `, [o("img", `
 width: 100%;
 `)])])]), r("text-type", [i("progress", `
 box-sizing: border-box;
 padding-bottom: 6px;
 margin-bottom: 6px;
 `)]), r("image-card-type", `
 position: relative;
 width: 96px;
 height: 96px;
 border: var(--n-item-border-image-card);
 border-radius: var(--n-border-radius);
 padding: 0;
 display: flex;
 align-items: center;
 justify-content: center;
 transition: border-color .3s var(--n-bezier), background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 overflow: hidden;
 `, [i("progress", `
 position: absolute;
 left: 8px;
 bottom: 8px;
 right: 8px;
 width: unset;
 `), i("upload-file-info", `
 padding: 0;
 width: 100%;
 height: 100%;
 `, [e("thumbnail", `
 width: 100%;
 height: 100%;
 display: flex;
 flex-direction: column;
 align-items: center;
 justify-content: center;
 font-size: 36px;
 `, [o("img", `
 width: 100%;
 `)])]), o("&::before", `
 position: absolute;
 z-index: 1;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 opacity: 0;
 transition: opacity .2s var(--n-bezier);
 content: "";
 `), o("&:hover", [o("&::before", "opacity: 1;"), i("upload-file-info", [e("thumbnail", "opacity: .12;")])])]), r("error-status", [o("&:hover", `
 background-color: var(--n-item-color-hover-error);
 `), i("upload-file-info", [e("name", "color: var(--n-item-text-color-error);"), e("thumbnail", "color: var(--n-item-text-color-error);")]), r("image-card-type", `
 border: var(--n-item-border-image-card-error);
 `)]), r("with-url", `
 cursor: pointer;
 `, [i("upload-file-info", [e("name", `
 color: var(--n-item-text-color-success);
 text-decoration-color: var(--n-item-text-color-success);
 `, [o("a", `
 text-decoration: underline;
 `)])])]), i("upload-file-info", `
 position: relative;
 padding-top: 6px;
 padding-bottom: 6px;
 display: flex;
 flex-wrap: nowrap;
 `, [e("thumbnail", `
 font-size: 18px;
 opacity: 1;
 transition: opacity .2s var(--n-bezier);
 color: var(--n-item-icon-color);
 `, [i("base-icon", `
 margin-right: 2px;
 vertical-align: middle;
 transition: color .3s var(--n-bezier);
 `)]), e("action", `
 padding-top: inherit;
 padding-bottom: inherit;
 position: absolute;
 right: 0;
 top: 0;
 bottom: 0;
 width: 80px;
 display: flex;
 align-items: center;
 transition: opacity .2s var(--n-bezier);
 justify-content: flex-end;
 opacity: 0;
 `, [i("button", [o("&:not(:last-child)", {
  marginRight: "4px"
}), i("base-icon", [o("svg", [a()])])]), r("image-type", `
 position: relative;
 max-width: 80px;
 width: auto;
 `), r("image-card-type", `
 z-index: 2;
 position: absolute;
 width: 100%;
 height: 100%;
 left: 0;
 right: 0;
 bottom: 0;
 top: 0;
 display: flex;
 justify-content: center;
 align-items: center;
 `)]), e("name", `
 color: var(--n-item-text-color);
 flex: 1;
 display: flex;
 justify-content: center;
 text-overflow: ellipsis;
 overflow: hidden;
 flex-direction: column;
 text-decoration-color: #0000;
 font-size: var(--n-font-size);
 transition:
 color .3s var(--n-bezier),
 text-decoration-color .3s var(--n-bezier); 
 `, [o("a", `
 color: inherit;
 text-decoration: underline;
 `)])])])]), i("upload-file-input", `
 display: none;
 width: 0;
 height: 0;
 opacity: 0;
 `)]);
export {
  p as default
};
